"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plugableRecord = void 0;
const type = Symbol();
exports.plugableRecord = {
    key(desc) {
        return Symbol(desc);
    },
    set(map, key, value) {
        map[key] = value;
    },
    get(map, key) {
        return map[key];
    },
    getAssure(map, key) {
        if (!map[key]) {
            throw new Error(`key ${key.description} is missing on map`);
        }
        return map[key];
    },
    getUnsafe(map, key) {
        return map[key];
    },
};
//# sourceMappingURL=plugable-record.js.map